const isRenderUnsubscribe = (cinemaData = false) => "cinemaDataProvider" === cinemaData?.cinemaNewsletterType

export default isRenderUnsubscribe